export enum MainDistributionEnum {
  Underground,
  Facade,
}
